var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("parent")]),_c('p',[_vm._v("msg:"+_vm._s(_vm.msg))]),_c('p',{ref:"p"},[_vm._v("获取dom")]),_c('button',{on:{"click":_vm.getDom}},[_vm._v("获取dom")]),_c('button',{on:{"click":_vm.getChild}},[_vm._v("获取children")]),_c('hr'),_c('Ceng1',{attrs:{"msg":_vm.msg},on:{"sendData":_vm.sendData}}),_c('hr'),_c('Ceng3',{ref:"ceng"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }